// extracted by mini-css-extract-plugin
module.exports = {"ourTeam":"ourTeam_ourTeam_1EtBi","show":"ourTeam_show_1btgt","hide":"ourTeam_hide_2UOFb","scrollBar":"ourTeam_scrollBar_mj15-","bar":"ourTeam_bar_3eycv"};